var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1211 25.623C46.1211 14.4425 37.068 5.37891 25.9004 5.37891C14.7328 5.37891 5.67969 14.4425 5.67969 25.623C5.67969 35.7274 13.0741 44.1024 22.7409 45.6211V31.4748H17.6068V25.623H22.7409V21.163C22.7409 16.0893 25.7597 13.2868 30.3786 13.2868C32.5909 13.2868 34.9049 13.6821 34.9049 13.6821V18.6641H32.3551C29.8432 18.6641 29.0599 20.2246 29.0599 21.8255V25.623H34.668L33.7715 31.4748H29.0599V45.6211C38.7267 44.1024 46.1211 35.7274 46.1211 25.623Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.643 31.3644L34.5309 25.5677H28.9764V21.806C28.9764 20.2201 29.7523 18.6743 32.2402 18.6743H34.7656V13.7393C34.7656 13.7393 32.4737 13.3477 30.2825 13.3477C25.7078 13.3477 22.7179 16.1238 22.7179 21.1497V25.5677H17.6328V31.3644H22.7179V45.3775C23.7531 45.5399 24.7993 45.6214 25.8472 45.6211C26.9118 45.6211 27.9568 45.5377 28.9764 45.3775V31.3644H33.643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb_logo.79418aa290a5ce320abf710bf64dd22e.svg";
export { ForwardRef as ReactComponent };